import { render, staticRenderFns } from "./printCPYXPurchases.vue?vue&type=template&id=57d2f03a&scoped=true&"
import script from "./printCPYXPurchases.vue?vue&type=script&lang=js&"
export * from "./printCPYXPurchases.vue?vue&type=script&lang=js&"
import style0 from "./printCPYXPurchases.vue?vue&type=style&index=0&id=57d2f03a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d2f03a",
  null
  
)

component.options.__file = "printCPYXPurchases.vue"
export default component.exports